module.exports = __webpack_public_path__ + "static/media/two-point-dice.ff8c087c.svg";